import { render, staticRenderFns } from "./JobOverviewList.vue?vue&type=template&id=c8d237c4&scoped=true&"
import script from "./JobOverviewList.vue?vue&type=script&lang=ts&"
export * from "./JobOverviewList.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c8d237c4",
  null
  
)

export default component.exports